export const EAppTracking = {
	fbInfo: 'trackingAppFbInfo',
	tiktokInfo: 'trackingAppFbInfo',
}